import React from 'react';

import { flagStyles } from '../settings';

const SvgNL = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-3936px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgNL;
